import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'cardTitle'
	| 'buildButtonLabel'
	| 'buildFlowInStudioButtonLabel'
	| 'buildingButtonLabel'
	| 'buildAutomationErrorTitle'
	| 'buildAutomationErrorDescription'
	| 'expandCardLabel'
	| 'collapseCardLabel';

const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.card-title',
		defaultMessage: 'Automation flow',
		description:
			'Title shown in the header of the automation plan card in the Rovo Create-with-Rovo chat. Labels the card that previews the automation the user is about to create. Used as a fallback when the generated automation has no name of its own.',
	},
	buildButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.build-button-label',
		defaultMessage: 'Build automation',
		description:
			'Label for the primary button at the bottom of the automation plan card. Pressing it creates the automation described in the card.',
	},
	buildFlowInStudioButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.build-flow-in-studio-button-label',
		defaultMessage: 'Build flow in Studio',
		description:
			'Label for the primary button at the bottom of the automation plan card when the card is shown outside Atlassian Studio, for example in Jira. Pressing it takes the user into Studio to build the automation there. "Studio" is the Atlassian Studio product name and must not be translated; "flow" is the Studio term for an automation.',
	},
	buildingButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.building-button-label',
		defaultMessage: 'Building...',
		description:
			'Label shown on the primary button at the bottom of the automation plan card while the automation is being created. Replaces the normal button label during the in-progress state; the trailing ellipsis signals that work is ongoing.',
	},
	buildAutomationErrorTitle: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.build-automation-error-title',
		defaultMessage: 'Failed to create automation',
		description:
			'Title of the error notification (flag) shown when creating the automation from the plan card fails.',
	},
	buildAutomationErrorDescription: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.build-automation-error-description',
		defaultMessage: 'Something went wrong while creating the automation. Please try again.',
		description:
			'Body text of the error notification (flag) shown when creating the automation from the plan card fails. Tells the user the action did not complete and asks them to retry.',
	},
	expandCardLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.expand-card-label',
		defaultMessage: 'Expand card',
		description:
			'Accessible label for the icon button in the automation plan card header. Pressing it expands the collapsed card to reveal the automation details.',
	},
	collapseCardLabel: {
		id: 'conversation-assistant-message-actions.studio-automation-create-flow.collapse-card-label',
		defaultMessage: 'Collapse card',
		description:
			'Accessible label for the icon button in the automation plan card header. Pressing it collapses the expanded card to hide the automation details.',
	},
});

export default messages;
